import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface StillWorkingModalData {
  shiftId: string;
  variant: 'first' | 'followup';
  shiftEndTime?: string;
  lastCheckInTime?: string;
}

@Injectable({ providedIn: 'root' })
export class StillWorkingModalService {
  private readonly _open$ = new Subject<StillWorkingModalData>();
  private readonly _closed$ = new Subject<'clockedOut' | 'stillWorking'>();

  /** Emits when the modal should be opened with the given data. */
  readonly open$ = this._open$.asObservable();

  /** Emits when the modal has been closed after a successful action. */
  readonly closed$ = this._closed$.asObservable();

  /** Request the layout to open the Still Working modal. */
  open(data: StillWorkingModalData): void {
    this._open$.next(data);
  }

  /** Notify subscribers that the modal was closed after an action. */
  notifyClosed(action: 'clockedOut' | 'stillWorking'): void {
    this._closed$.next(action);
  }
}
